
// import {SuperDebug, ServerDebug} from '../../../utils/debug/Sdebug';
// let debug_b = ServerDebug('browser', false);

export class Browser {

    public static showBatchUploadTip() {    // 是否显示批量上传提示信息
        let bool_is_android         = this.isAndroid();          // 是否为安卓浏览器
        let bool_is_m_qq_browser    = this.isMobileQQBrowser();  // 是否是 移动端 QQ 浏览器
        return  bool_is_android && !bool_is_m_qq_browser;
    }

    // 是否是 移动版的 QQ 浏览器
    public static isMobileQQBrowser() {
        let ret = false;
        let ua = navigator.userAgent;
        ua = ua.toLowerCase();
        if (ua.indexOf('mqqbrowser/') !== -1) {
            ret = true;
        }
        return ret;
    }

    public static isInWeChatBrowser() {
        let ret = false;
        let ua = navigator.userAgent;
        ua = ua.toLowerCase();
        if (ua.indexOf('micromessenger') !== -1) {
            ret = true;
        }
        return ret;
    }

    public static userAgent() {
        return navigator.userAgent;
    }

    public static isIOS() {
        let ua = this.userAgent().toLowerCase();
        let bool = false;
        if (ua.indexOf('mac os x') !== -1) {
            bool = true;
        }
        return bool;
    }

    public static isAndroid() {
        let ua = this.userAgent().toLowerCase();
        let bool = false;
        if (ua.indexOf('linux') !== -1) {
            bool = true;
        }
        return bool;
    }

    public static isSecure() {
        return  location.protocol.toString().indexOf('https') !== -1;
    }

    public static autoScheme() {
        return  this.isSecure() ? 'https' : 'http';
    }

}
